import React from "react";

export default () => <div className="container-fluid">
  <div className="page-header">
    <h1>
      About The Project
    </h1>
  </div>

  <div className="row">
    <div className="col-md-12">
      <p style={{fontSize: 'large'}}>
        <b><i className="text-success">Slowness Kills</i></b> is a project by <a target="_blank" href="https://www.sergeychernyshev.com/" rel="noopener noreferrer">Sergey Chernyshev</a> who cares about performance and <span className="text-danger">can&apos;t stand slow sites</span>.
      </p>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/About.jsx